import { InternalAxiosRequestConfig } from 'axios';

import { env } from '../../app/env';

export async function tenantInterceptor(
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> {
  if (config.headers) {
    config.headers['x-tenant-id'] = env.TENANT_ID;
  }

  return config;
}
